import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

interface PassthroughPrefixWorkflowWarningModalProps {
  opened: boolean;
  selectedPrefix: string | null;
  workflowLabel: string;
  isCompleting: boolean;
  onClose: () => void;
  onCompleteAnyway: () => void;
  onReview: () => void;
}

export default function PassthroughPrefixWorkflowWarningModal({
  opened,
  selectedPrefix,
  workflowLabel,
  isCompleting,
  onClose,
  onCompleteAnyway,
  onReview,
}: PassthroughPrefixWorkflowWarningModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Check pass-through prefix"
      centered
      withinPortal
      size="sm"
    >
      <Stack gap="md">
        <Alert
          icon={<IconAlertTriangle size={16} />}
          color="yellow"
          variant="light"
          role="alert"
        >
          A passthrough prefix, {selectedPrefix} has been selected but the
          workflow is {workflowLabel}.
        </Alert>

        <Text size="sm">
          Check that the case materials are selected correctly before completing
          accessioning. You can complete anyway, or go back and fix the prefix
          or materials first.
        </Text>

        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onReview}>
            Review/Go back and fix
          </Button>
          <Button onClick={onCompleteAnyway} loading={isCompleting}>
            Complete anyway
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
